import React from 'react';
import { useField } from 'react-final-form';
import * as Styled from '../AudioScriptPlaybackCard.styled';

const ReadyPlaybackCard = () => {
  // Get AI voice value from form to determine colors
  const {
    input: { value: aiVoice },
  } = useField('aiVoice');

  return (
    <Styled.Container variant="highlight" selectedVoice={aiVoice}>
      <Styled.Content>
        <Styled.EnhanceActiveIcon size="xxlarge" rotate="180" />
        <Styled.TextContainer>
          <Styled.Text>We see the vision.</Styled.Text>
          <Styled.Caption>
            We&apos;re ready to generate your audio.
          </Styled.Caption>
        </Styled.TextContainer>
      </Styled.Content>
    </Styled.Container>
  );
};

export default ReadyPlaybackCard;
